<nav class="navbar navbar-expand-lg navbar-dark">
  
    <div class="px-3 py-2">
      <a class="navbar-brand d-flex align-items-center" href="#">
        <img src="../assets/img/spades-calc.png" width="33px" style="filter: invert(1); margin-right: 5px;">
        Spades calculator
      </a>
    </div>
      
    <div class="px-3 py-2">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
    
    <div class="collapse navbar-collapse bg-2 px-3" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" aria-current="page" href="/">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/solo" routerLinkActive="active">Solo</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/teams" routerLinkActive="active">Team</a>
        </li>
      </ul>
    </div>
  
</nav>

<router-outlet></router-outlet>

<footer class="footer text-center pt-5">
  <img src="../assets/img/spades-calc@3x.png" width="90px" style="filter: invert(1);">
  <br>
  Made by <a href="https://www.philipdev.se">Philipdev</a>
</footer>